import {isTruthy} from "../utils/DBUtils";

class ResourceField {
    resourceState = null;
    resourceId = "";
    fieldName = "";

    constructor(resourceState, resourceId, field) {
        this.resourceState = resourceState;
        this.resourceId = resourceId;
        this.fieldName = field;
    }

    get isSaving() {
        return this.resourceState.isSaving(this.resourceId, this.field);
    }

    get value() {
        return this.resourceState.getRawResource(this.resourceId)[this.field];
    }

    get field() {
        return this.fieldName;
    }

    get hasError() {
        return isTruthy(this.resourceState.getSaveError(this.resourceId, this.fieldName));
    }

    get error() {
    }

    get actualValue() {
        return this.hasError ? this.resourceState.getSaveError(this.resourceId, this.fieldName).actualValue : "";
    }
}

export default ResourceField;


// WEBPACK FOOTER //
// ./public/classes/ResourceField.js